import { LayoutController } from "onearm";
import gsap from "gsap";
import { formatCurrency } from "../../utils/formatCurrency.js";

export class LineWinDisplay extends LayoutController {
    init() {
        this._currency = this.options.currency || "";
        this._container = this.find("winContainer");
        this._valueText = this.find("winContainer.value");
        this.hide();
    }

    setValue(value) {
        if (this._valueText) {
            this._valueText.text = formatCurrency(value, this._currency);
        }
    }

    fadeIn({ duration = 0.2 } = {}) {
        const tl = gsap.timeline();
        const container = this._container;
        if (!container) return tl;
        tl.add(() => {
            container.alpha = 0;
            container.visible = true;
        });
        tl.to(container, { alpha: 1, duration, ease: "sine.out" });
        return tl;
    }

    fadeOut({ duration = 0.2 } = {}) {
        const tl = gsap.timeline();
        const container = this._container;
        if (!container) return tl;
        tl.to(container, { alpha: 0, duration, ease: "sine.in" });
        tl.add(() => { container.visible = false; });
        return tl;
    }

    hide() {
        const container = this._container;
        if (!container) return;
        gsap.killTweensOf(container);
        container.alpha = 0;
        container.visible = false;
    }

    onDestroy() {
        this.hide();
    }
}
